import { createContext, useContext, useReducer } from "react";
import toast from "react-hot-toast";

const CartContext = createContext();

const initialState = {
  cart: JSON.parse(localStorage.getItem("cart")) || [
    {
      itemName: "t-shirt",
      unitPrice: 6,
      quantity: 1,
      itemID: 1,
      totalPrice: 1,
      itemImage:
        "https://firebasestorage.googleapis.com/v0/b/e-commerce-project-59e02.appspot.com/o/11a-min.png?alt=media&token=37c71e54-d412-4ea5-a685-832eec11ddb9",
    },
  ],
};

function reducer(state, action) {
  switch (action.type) {
    case "cart/addItem":
      const newItem = {
        ...action.payload,
        totalPrice: action.payload.quantity * action.payload.unitPrice,
      };
      localStorage.setItem("cart", JSON.stringify([...state.cart, newItem]));

      return { ...state, cart: [...state.cart, newItem] };
    case "cart/deleteItem":
      const newCart = state.cart.filter(
        (item) => item.itemID !== action.payload
      );
      localStorage.setItem("cart", JSON.stringify(newCart));

      return { ...state, cart: newCart };
    case "cart/updateItemQuantity":
      const newCartUpdate = state.cart.map((item) => {
        if (item.itemID === action.payload.id) {
          console.log(item);
          item.quantity = action.payload.quantity;
          item.totalPrice = item.unitPrice * item.quantity;
        }

        return item;
      });
      localStorage.setItem("cart", JSON.stringify(newCartUpdate));
      return { ...state, cart: newCartUpdate };

    case "cart/clearCart":
      console.log("cleared");
      localStorage.setItem("cart", JSON.stringify([]));
      return { ...state, cart: [] };

    default:
      throw new Error("unsupported action");
  }
}

// action functions
function addItem(newItem) {
  toast.success("Product has been added to cart successfully");
  return { type: "cart/addItem", payload: newItem };
}

function deleteItem(id) {
  toast.success("Product has been deleted from cart successfully");
  return { type: "cart/deleteItem", payload: id };
}

function updateItemQuantity(id, quantity) {
  return { type: "cart/updateItemQuantity", payload: { id, quantity } };
}

function clearCart() {
  return { type: "cart/clearCart" };
}

function CartContextProvider({ children }) {
  const [{ cart }, dispatch] = useReducer(reducer, initialState);
  console.log(cart);

  return (
    <CartContext.Provider
      value={{
        cart,
        dispatch,
        addItem,
        deleteItem,
        updateItemQuantity,
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

function useCartContext() {
  const context = useContext(CartContext);
  if (context === "undefined")
    throw new Error(
      "The CartContext cannot be used outside the contextProvider 🥵"
    );
  return context;
}

export { CartContextProvider, useCartContext };
